<template>
	<div class="index-login p-b-70 propay">
		<!-- 初始空白 -->
		<div v-if="loading"></div>
		<!-- 授权加载 -->
		<div v-else>
			<div class="main" :style="'background:'+ colorList[0]">
				<img :src="baseUrl+ imagesList[0]" />
				<div class="cbtn" @click="submitForm(0)" :style="'background:'+ colorList[2]">
					<div class="text">立即点击报名</div>
				</div>

				<img :src="baseUrl+item" v-for="(item, index) in imagesList" :key="index" v-if="index > 0" />
			</div>
			<div class="footer">
				<div class="price">{{ produInfo.productPrice }}</div>
				<div class="text" @click="submitForm(1)">
					<div class="breathe">立即报名</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { clickThrottle, getAgent } from '@/utils/index'

	export default {
		data () {
			return {
				baseUrl:`${this.$siteURL}/imgs/mini/`,
				colorList:[],
				customerId:'',
				imagesList:[],
				loading:true,
				orderId:'',
				pathId:'',
				productId:1,
				produInfo:{},
			}
		},
		created(){
			this.productId = this.$route.query.productId || 1
			this.feedBack()
			this.getProduct()
		},
		methods:{
			async feedBack(){
				let data = await this.pathBack(window.location.href)
				this.customerId = data.customerId
				this.pathId = data.pathId
				this.$store.commit("SET_PATHID", data.pathId)
			},
      		getProduct(){
				axios({
					method:'GET',
					url: `${this.$baseURL}/queryProductInfo`,
					params:{
						productId: this.productId
					}
				}).then(res => {
					this.loading = false
					this.produInfo = res.data
					this.imagesList = res.data.images
					this.colorList = res.data.theme && res.data.theme.indexOf(',') > 0 ? res.data.theme.split(',') : ['#fff','#1ACE9A','#1ACE9A']
				})
			},
			submitForm(val) {
				if(!clickThrottle(2000)) return
				this.commonPoint(this.pathId,this.productId,'ecApplyNow',val)
				this.login()
			},
			login(){
				this.commonPoint(this.pathId,this.productId,'insertApplyEc',0)
				axios({
					method:'POST',
					url: `${this.$baseURL}/userOrders`,
					params:{
						customerId:this.customerId,
						pathId:this.pathId,
						productId: this.productId,
						userPhone:''
					}
				}).then(res => {
					this.orderId = res.data.data.code
					if(res.data.code == 200){
						this.openWechatLink()
					}else{
						this.$message({message: res.data.message});
					}
				})
			},
			openWechatLink(){
				axios({
					method:"POST",
					url:`${this.$baseURL}/getWechatLinkFree`,
					params:{
						pathId: this.pathId,
						productId: this.productId,
						orderId: this.orderId
					}
				}).then(res => {
					if(res.data.code == 200){
						let data = res.data.data
						let path = data.link_url + '?customer_channel=' + data.orderId + '_H5' + '_' + this.productId
						this.openUrl(path)
					}else{
						this.$message({message: res.data.message});
					}
				})
			},
			openUrl(path){
				if(getAgent()){
					window.open(path)
				}else{
					window.location.href = path
				}
			},
		}
	}
</script>


<style scoped>
	.footer{background-image: url('./../../assets/images/btn2.png');}
	.price{color: #ff4242;position: absolute;left: 20px;bottom: 8px;font-size: 42px;font-weight: bold;}

	.pay-type{display: flex;justify-content: space-around;}
	.pay-type .item{text-align: center;background: #F2F2F2;font-size: 18px;color: #333;;width: 35%;padding: 15px;border-radius: 10px;border: 1px solid #F2F2F2;}
	.pay-type .item.on{background: #F6E5E5;border-color: #FF0000;}
	.pay-type .item img{width: 35px;height: 35px;}
	.el-button.is-round{width: 100%;background: linear-gradient(90deg, #ff4242 0%, #ff7e18 100%);border: none;color: #fff;font-size: 20px;}
	
	.panel{background: url(../../assets/images/retain.png) no-repeat;width: 100%;height: 82vw;background-size: cover;    margin-top: 40%;position: relative;}
	.panel .df{position: absolute;bottom: 0;left: 0;right: 0;justify-content: center;}
	.panel .btn{padding: 10px 20px;border-radius: 10px;margin: 20px 15px 40px;font-size: 20px;font-weight: bold;}
	.panel .left{color: #7D2500;border: 1px solid #7D2500;}
	.panel .right{color: #fff;background: linear-gradient(90deg, #FF0000 0%, #FF7200 100%);}

	.panel2{background-image: url(../../assets/images/pay.png);border-radius: 20px;width: calc(100% - 30px);height: 96vw;margin-left: auto;margin-right: auto;max-height: 666px;max-width: 641px;}
	.panel2 .btn{padding: 10px;margin: 20px 10px;font-weight: normal;}

	.cbtn{margin: 20px 30px 0px;padding: 18px 25px;background: #1ACE9A;text-align: center;border-radius: 35px;margin-bottom: 20px;}
	.cbtn .text{animation: testAnimation 1.5s linear infinite;color: #fff;font-size: 1.5rem;letter-spacing: 2px;font-weight: bold;cursor: pointer;}
	/* css3 */
	@keyframes testAnimation {
		0%{
			transform: scale(.9);
		}
		50%{
			transform: scale(1.2);
		}
		100%{
			transform: scale(.9);
		}
	}

	@media screen and (min-width:740px){
		.price{font-size: 90px;bottom:15px;}
	}
</style>



// WEBPACK FOOTER //
// src/views/product/custIndex.vue